import { defineEvent } from "@visioni/a3s-analytics";

/** The site picked on the vehicle search; absent for all sites. */
type SiteScope = { site_id: string | undefined };

export const VehicleExportOpened = defineEvent<SiteScope>("Vehicle Export Opened");
/** `truncated` when more sightings matched than the row limit allows. */
export const VehicleExportDownloaded = defineEvent<SiteScope & { row_count: number; truncated: boolean }>(
  "Vehicle Export Downloaded",
);
export const VehicleExportFailed = defineEvent<SiteScope & { reason: "range_too_large" | "error" }>(
  "Vehicle Export Failed",
);
export const VehicleExportCancelled = defineEvent<SiteScope>("Vehicle Export Cancelled");
